module.exports = __webpack_public_path__ + "static/media/jardín.ead7d37b.png";